<app-panel
  [title]="'Magazyn pojazdów'"
  class="vehicles-panel relative">
  <div class="table-container">
    @if (orchestrator.items$ | async; as items) {
      <p-table
        #vehicleSearchTable
        [value]="items"
        [loading]="orchestrator.isLoading()"
        [scrollable]="true"
        [scrollHeight]="'flex'"
        (onRowSelect)="onRowSelect($event)"
        [selectionMode]="items.length > 0 ? 'multiple' : null"
        [class.expand-v]="!items.length"
        (onLazyLoad)="onFilter($event)"
        [lazy]="true"
        size="small"
        dataKey="id"
        class="size-full">
        <ng-template pTemplate="header">
          <tr class="text-sm">
            <th scope="row">
              <div class="inline-flex items-center justify-between gap-2">
                <span>Marka</span>
                <p-columnFilter field="brand" display="menu" matchMode="in"
                                [showMatchModes]="false" [showOperator]="false" [showAddButton]="false"
                                [showApplyButton]="false"
                                [showClearButton]="false"
                                (onShow)="onBrandFilterShow()" (onHide)="onBrandFilterHide()">
                  <ng-template #filter let-filterValue let-filterCallback="filterCallback">
                    <app-multiselect-input
                      class="w-[300px]"
                      [options]="orchestrator.vehicleBrands$ | async"
                      [ngModel]="filterValue"
                      (ngModelChange)="filterCallback($event)"
                      (rawSelectionChange)="onBrandFilterChange($event)"
                      [filter]="true"
                      [showLoading]="orchestrator.isLoading()"
                      filterPlaceholder="Filtruj po markach"
                      optionValue="displayName"
                      appendTo="self"
                      placeholder="Wyszukaj marki">
                    </app-multiselect-input>
                    <p-button
                      label="Wyczyść filtr"
                      (onClick)="filterCallback(null)"
                      rounded
                      outlined
                      size="small">
                    </p-button>
                  </ng-template>
                </p-columnFilter>
              </div>
            </th>
            <th scope="row">
              <div class="flex items-center gap-2">
                <span>Model</span>
                @if (brandsSelected()) {
                  <p-columnFilter field="model" display="menu" matchMode="in"
                                  [showMatchModes]="false" [showOperator]="false" [showAddButton]="false"
                                  [showApplyButton]="false"
                                  [showClearButton]="false"
                                  (onShow)="onModelFilterShow()">
                    <ng-template #filter let-filterValue let-filterCallback="filterCallback">
                      <app-multiselect-input
                        class="w-[300px]"
                        [options]="orchestrator.vehicleModels$ | async"
                        [ngModel]="filterValue"
                        (ngModelChange)="filterCallback($event)"
                        [filter]="true"
                        [showLoading]="orchestrator.isLoading()"
                        optionValue="displayName"
                        filterPlaceholder="Filtruj po modelach"
                        appendTo="self"
                        placeholder="Wyszukaj modele">
                      </app-multiselect-input>
                      <p-button
                        label="Wyczyść filtr"
                        (onClick)="filterCallback(null)"
                        rounded
                        outlined
                        size="small">
                      </p-button>
                    </ng-template>
                  </p-columnFilter>
                }
              </div>
            </th>
            <th scope="row">
              <div class="flex items-center gap-2">
                <span>Status</span>
              </div>
            </th>
            <th scope="row">
              <div class="flex items-center gap-2">
                Nr. rejestracyjny
                <p-columnFilter field="registrationPlate" display="menu" matchMode="contain" [showClearButton]="false"
                                [showMatchModes]="false"
                                [showOperator]="false" [showAddButton]="false" [showApplyButton]="false">
                  <ng-template pTemplate="filter" let-filterValue let-filterCallback="filterCallback">
                    <app-text-input
                      [ngModel]="filterValue"
                      (ngModelChange)="filterCallback($event)"
                      placeholder="Filtruj po rejestracji">
                    </app-text-input>
                    <p-button
                      label="Wyczyść filtr"
                      (onClick)="filterCallback(null)"
                      rounded
                      outlined
                      size="small">
                    </p-button>
                  </ng-template>
                </p-columnFilter>
              </div>
            </th>
            <th scope="row">
              <div class="flex items-center gap-2">
                <span>Nr. fabryczny</span>
                <p-columnFilter field="factoryNumber" display="menu" matchMode="contain" [showMatchModes]="false"
                                [showClearButton]="false"
                                [showOperator]="false" [showAddButton]="false" [showApplyButton]="false">
                  <ng-template pTemplate="filter" let-filterValue let-filterCallback="filterCallback">
                    <app-text-input
                      [ngModel]="filterValue"
                      (ngModelChange)="filterCallback($event)"
                      placeholder="Filtruj po SN">
                    </app-text-input>
                    <p-button
                      label="Wyczyść filtr"
                      (onClick)="filterCallback(null)"
                      rounded
                      outlined
                      size="small">
                    </p-button>
                  </ng-template>
                </p-columnFilter>
              </div>
            </th>
            <th scope="row">
              <div class="flex items-center gap-2">
                <span>Nr. dokumentów</span>
                <p-columnFilter field="documentNumber" display="menu" matchMode="contain" [showMatchModes]="false"
                                [showOperator]="false" [showAddButton]="false" [showApplyButton]="false">
                  <ng-template pTemplate="filter" let-filterValue let-filterCallback="filterCallback">
                    <app-text-input
                      [ngModel]="filterValue"
                      (ngModelChange)="filterCallback($event)"
                      placeholder="Filtruj po dokumencie">
                    </app-text-input>
                    <p-button
                      label="Wyczyść filtr"
                      (onClick)="filterCallback(null)"
                      rounded
                      outlined
                      size="small">
                    </p-button>
                  </ng-template>
                </p-columnFilter>
              </div>
            </th>
            <th scope="row">
              <div class="flex items-center gap-2">
                Nr. kluczyka
                <p-columnFilter field="keyNumber" display="menu" matchMode="contain" [showMatchModes]="false"
                                [showClearButton]="false"
                                [showOperator]="false" [showAddButton]="false" [showApplyButton]="false">
                  <ng-template pTemplate="filter" let-filterValue let-filterCallback="filterCallback">
                    <app-text-input
                      [ngModel]="filterValue"
                      (ngModelChange)="filterCallback($event)"
                      placeholder="Filtruj po kluczyku">
                    </app-text-input>
                    <p-button
                      label="Wyczyść filtr"
                      (onClick)="filterCallback(null)"
                      rounded
                      outlined
                      size="small">
                    </p-button>
                  </ng-template>
                </p-columnFilter>
              </div>
            </th>
            <th scope="row">
              <div class="flex items-center gap-2">
                <span>VIN</span>
                <p-columnFilter field="vin" display="menu" matchMode="contain" [showMatchModes]="false"
                                [showOperator]="false" [showAddButton]="false" [showApplyButton]="false">
                  <ng-template pTemplate="filter" let-filterValue let-filterCallback="filterCallback">
                    <app-text-input
                      class="w-[300px]"
                      [ngModel]="filterValue"
                      (ngModelChange)="filterCallback($event)"
                      placeholder="Filtruj po VIN">
                    </app-text-input>
                    <p-button
                      label="Wyczyść filtr"
                      (onClick)="filterCallback(null)"
                      rounded
                      outlined
                      size="small">
                    </p-button>
                  </ng-template>
                </p-columnFilter>
              </div>
            </th>
            <th scope="row" pSortableColumn="returnDate">
              <div class="flex items-center gap-2">
                Data przyjęcia
                <p-sortIcon field="returnDate"/>
                <p-columnFilter field="returnDate" display="menu" matchMode="contain" [showMatchModes]="false"
                                [showOperator]="false" [showAddButton]="false" [showApplyButton]="false"
                                [showClearButton]="false">
                  <ng-template pTemplate="filter" let-returnDate let-returnDateCallback="returnDateFilterCallback">
                    <div class="flex flex-col gap-2 items-start justify-start">
                      <span>Podaj zakres czasu</span>
                      <div class="inline-flex items-center gap-2">
                        <app-date-input
                          [ngModel]="returnDateFrom()"
                          (ngModelChange)="returnDateFrom.set($event)"
                          [showTime]="true"
                          [untilNow]="true"
                          [maxDate]="returnDateTo()">
                        </app-date-input>
                        <span>-</span>
                        <app-date-input
                          [ngModel]="returnDateTo()"
                          (ngModelChange)="returnDateTo.set($event)"
                          [showTime]="true"
                          [untilNow]="true">
                        </app-date-input>
                      </div>
                    </div>
                    <div class="w-full inline-flex items-center justify-start gap-2 mt-5 p-0">
                      <p-button
                        label="Wyczyść filtr"
                        (onClick)="onClearReturnDateFilter()"
                        rounded
                        outlined
                        size="small">
                      </p-button>
                      <p-button
                        label="Zastosuj filtr"
                        (onClick)="onApplyReturnDateFilter()"
                        rounded
                        size="small">
                      </p-button>
                    </div>
                  </ng-template>
                </p-columnFilter>
              </div>
            </th>
            <th scope="row" pSortableColumn="releaseDate">
              <div class="flex items-center gap-2">
                Data wydania
                <p-sortIcon field="releaseDate"/>
                <p-columnFilter field="releaseDate" display="menu" matchMode="contain" [showMatchModes]="false"
                                [showOperator]="false" [showAddButton]="false" [showApplyButton]="false"
                                [showClearButton]="false">
                  <ng-template pTemplate="filter" let-releaseDate let-releaseDateCallback="releaseDateFilterCallback">
                    <div class="flex flex-col gap-2 items-start justify-start">
                      <span>Podaj zakres czasu</span>
                      <div class="inline-flex items-center gap-2">
                        <app-date-input
                          [ngModel]="releaseDateFrom()"
                          (ngModelChange)="releaseDateFrom.set($event)"
                          [showTime]="true"
                          [untilNow]="true"
                          [maxDate]="releaseDateTo()">
                        </app-date-input>
                        <span>-</span>
                        <app-date-input
                          [ngModel]="releaseDateTo()"
                          (ngModelChange)="releaseDateTo.set($event)"
                          [showTime]="true"
                          [untilNow]="true">
                        </app-date-input>
                      </div>
                    </div>
                    <div class="w-full inline-flex items-center justify-start gap-2 mt-5 p-0">
                      <p-button
                        label="Wyczyść filtr"
                        (onClick)="onClearReleaseDateFilter()"
                        rounded
                        outlined
                        size="small">
                      </p-button>
                      <p-button
                        label="Zastosuj filtr"
                        (onClick)="onApplyReleaseDateFilter()"
                        rounded
                        size="small">
                      </p-button>
                    </div>
                  </ng-template>
                </p-columnFilter>
              </div>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-vehicle>
          <tr [pSelectableRow]="vehicle">
            <td>{{ vehicle.brand }}</td>
            <td>{{ vehicle.model }}</td>
            <td>
              <div class="inline-flex items-center justify-start gap-1">
                <div class="w-2 h-2 opacity-40 rounded-full" [style.background-color]="vehicle.statusColor"></div>
                <span>
                  {{ vehicle.statusLabel }}
                </span>
              </div>
            </td>
            <td class="max-w-[75px] text-sm truncate">{{ vehicle.displayRegistrationPlate }}</td>

            <td class="max-w-[150px] text-sm truncate">{{ vehicle.displayFactoryNumber }}</td>
            <td>{{ vehicle.displayDocumentNumber }}</td>
            <td>{{ vehicle.displayKeyNumber }}</td>
            <td class="max-w-[150px] text-sm truncate">{{ vehicle.displayVin }}</td>
            <td class="text-sm">{{ vehicle.displayReturnDate }}</td>
            <td class="text-sm">{{ vehicle.displayReleaseDate }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr class="size-full">
            <td colspan="10" class="h-full">
              <div class="flex flex-col items-center justify-center h-full">
                <div class="flex flex-col items-center justify-center gap-1 p-8 rounded-2xl">
                  <h3 class="text-xl font-semibold text-surface-700">
                    Brak wyników
                  </h3>
                  <span class="text-surface-500 text-sm">
                  Nie znaleziono żadnych pojazdów
                </span>
                  <p-button
                    (onClick)="onAddVehicle()"
                    class="mt-2"
                    severity="primary"
                    rounded
                    outlined
                    size="small">
                    Dodaj pojazd
                  </p-button>
                </div>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    }
  </div>

  <div class="paginator-container">
    <p-paginator
      [rows]="orchestrator.pageSize()"
      [totalRecords]="orchestrator.totalElements()"
      [first]="orchestrator.currentPage() * orchestrator.pageSize()"
      [rowsPerPageOptions]="[10, 20, 50, 100]"
      (onPageChange)="orchestrator.onPageChange($event)"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="{first} - {last} z {totalRecords} pojazdów"
    />
  </div>
</app-panel>
<p-button
  (onClick)="onAddVehicle()"
  pTooltip="Dodawanie pojazdu"
  class="absolute bottom-8 right-8"
  icon="pi pi-plus"
  rounded
  severity="primary">
</p-button>
